module.exports = "<div class=\"row mb-3\">\r\n  <div class=\"col\">\r\n    <app-table-card header=\"{{headerText}}\" icon=\"pax.png\" collapsible=true collapsed=true>\r\n      <ng2-smart-table [settings]=\"tableSettings\" [source]=\"passengers\"></ng2-smart-table>\r\n    </app-table-card>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/confirmation-view/passenger-listing-table/passenger-listing-table.component.html
// module id = ./src/app/shared/components/confirmation-view/passenger-listing-table/passenger-listing-table.component.html
// module chunks = main